import nopAccessLogoSrc from '@cp/assets/images/transmedicsLogo.svg?url';

import {
  CUSTOMER_ROLE_NAMES,
  CUSTOMER_ROLE_DESCRIPTIONS,
  CUSTOMER_ROLE_WEIGHT,
  OPO_ROLE_NAMES,
  OPO_ROLE_DESCRIPTIONS,
  OPO_ROLE_WEIGHT,
} from '@/constants/customer.constants';

import { PlatformConfig, PlatformType } from './platform.types';

export const NOP_ACCESS_CONFIG = {
  type: PlatformType.NopAccess,
  label: 'NOP Access',
  logo: {
    src: nopAccessLogoSrc,
    alt: 'Transmedics | NOP Access',
  },
  features: {
    canAccessArchive: true,
    canAccessOpoList: true,
    canAccessOrganApproval: true,
    canAccessServiceApproval: true,
    canAccessQuoteApproval: true,
    canAccessInvoice: true,
    canAccessFullActivityLog: true,
    canAccessDefaultOrganAcceptanceCriteria: true,
    canEditAcceptanceCriteria: true,
    canAccessMapTracking: true,
    canAccessCaseNotes: true,
    canAccessTxCenterOrganization: true,
    canAccessOpoOrganizationPage: false,
    canAccessOpoClinicalRequest: false,
    canAccessOpoLabel: true,
    canAccessOpoReleaseNotes: false,
    canManageAttachments: true,
    canManageDraftAttachments: false,
    canCreateDonorHospital: true,
    canAccessOffers: true,
    canEditOpoContactsBeyondOrganOnOcs: true,
  },
  roleConfig: {
    roleNames: CUSTOMER_ROLE_NAMES,
    roleDescriptions: CUSTOMER_ROLE_DESCRIPTIONS,
    roleWeight: CUSTOMER_ROLE_WEIGHT,
  },
} satisfies PlatformConfig;

// TODO: Replace logo src with a proper OPO Access logo once the asset is available
export const OPO_ACCESS_CONFIG = {
  type: PlatformType.OpoAccess,
  label: 'OPO Access',
  logo: {
    src: nopAccessLogoSrc,
    alt: 'Transmedics | OPO Access',
  },
  features: {
    canAccessArchive: false,
    canAccessOpoList: false,
    canAccessOrganApproval: false,
    canAccessServiceApproval: false,
    canAccessQuoteApproval: false,
    canAccessInvoice: false,
    canAccessFullActivityLog: false,
    canAccessDefaultOrganAcceptanceCriteria: false,
    canEditAcceptanceCriteria: false,
    canAccessMapTracking: false,
    canAccessCaseNotes: false,
    canAccessTxCenterOrganization: false,
    canAccessOpoOrganizationPage: true,
    canAccessOpoClinicalRequest: true,
    canAccessOpoLabel: false,
    canAccessOpoReleaseNotes: true,
    canManageAttachments: false,
    canManageDraftAttachments: true,
    canCreateDonorHospital: false,
    canAccessOffers: false,
    canEditOpoContactsBeyondOrganOnOcs: false,
  },
  roleConfig: {
    roleNames: OPO_ROLE_NAMES,
    roleDescriptions: OPO_ROLE_DESCRIPTIONS,
    roleWeight: OPO_ROLE_WEIGHT,
  },
} satisfies PlatformConfig;

const PLATFORM_CONFIGS = {
  [PlatformType.NopAccess]: NOP_ACCESS_CONFIG,
  [PlatformType.OpoAccess]: OPO_ACCESS_CONFIG,
} satisfies Record<PlatformType, PlatformConfig>;

const isPlatformType = (mode: string): mode is PlatformType => mode in PLATFORM_CONFIGS;

export const getPlatformConfig = (mode?: string): PlatformConfig => {
  if (mode && isPlatformType(mode)) {
    return PLATFORM_CONFIGS[mode];
  }

  return NOP_ACCESS_CONFIG;
};
